module.exports = __webpack_public_path__ + "img/colorful-pills-wooden-spoons.09373846.png";